const API_BASE = '/api';

function getToken() {
  return localStorage.getItem('neon_token') || localStorage.getItem('token') || '';
}

function clearInvalidSession() {
  localStorage.removeItem('neon_token');
  localStorage.removeItem('token');
  localStorage.removeItem('neon_user');
  window.dispatchEvent(new Event('neon-auth-expired'));
  if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
    window.location.href = '/admin/login?expired=1';
  }
}

async function request(method, path, body) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  const token = getToken();
  if (token) opts.headers['Authorization'] = `Bearer ${token}`;
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(API_BASE + path, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    if (res.status === 401) clearInvalidSession();
    const error = new Error(err.error || err.message || `HTTP ${res.status}`);
    error.status = res.status;
    error.data = err;
    throw error;
  }
  return res.json();
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  patch: (path, body) => request('PATCH', path, body),
  del: (path) => request('DELETE', path),
};
